import posthog from "posthog-js";

const POSTHOG_KEY =
  import.meta.env.VITE_POSTHOG_KEY ?? "phc_Tn7VwYeF9rBKXaQSPwMd38ivoKB2r13tJYkOYWRkrMJ";
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST ?? "https://eu.posthog.com";

let initialized = false;

export function initPostHog(): void {
  if (typeof window === "undefined") return;
  if (initialized) {
    // VP-312: ponowna zgoda po wycofaniu — instancja żyje, ale siedzi w opt-out.
    posthog.opt_in_capturing();
    posthog.startSessionRecording();
    return;
  }

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: "identified_only",
    session_recording: {
      maskAllInputs: true,
      maskInputOptions: {
        password: true,
        email: false,
      },
    },
    capture_pageview: true,
    capture_pageleave: true,
    capture_exceptions: true,
    autocapture: {
      dom_event_allowlist: ["click", "submit", "change"],
    },
    loaded: () => {
      if (import.meta.env.DEV) {
        // eslint-disable-next-line no-console
        console.debug("[PostHog] loaded");
      }
    },
  });

  initialized = true;
}

/**
 * VP-312: wycofanie zgody analitycznej musi ZATRZYMAĆ PostHoga w tej samej sesji —
 * samo skasowanie ciasteczek nie wystarcza, bo persystencja siedzi też w localStorage,
 * a nagrywanie sesji leciałoby dalej do przeładowania strony.
 */
export function stopPostHog(): void {
  if (!initialized) return;

  posthog.stopSessionRecording();
  // Kolejność ma znaczenie: reset() czyści też zapisaną decyzję opt-out, więc gdyby
  // poszedł na końcu, PostHog wróciłby do stanu "pending" i zaczął zbierać od nowa.
  posthog.reset();
  posthog.opt_out_capturing();
}

export { posthog };
